import React from 'react';
import { Trans, withTranslation } from 'react-i18next';
import { Message, EmptyIcon, Text, InternalGrid } from '@paygreen/paygreen-ui';
import { IsMobile } from '../../../utils/tools';

const NoDataFoundMessage = ({ t, partner }) => (
    <Message colorPallet="status" hasStaticWidth={true} blockWidth="md">
        <InternalGrid
            displayType="grid"
            gridTemplateColumns="auto 1fr"
            gridGap="md"
            alignItems={IsMobile() ? 'flex-start' : 'center'}
        >
            <EmptyIcon colorPallet="status" iconSize="md" />

            <Text colorPallet="status" textSize="xs" data-cy="no-data-sentence">
                <Trans
                    i18nKey="dashboard.noDataFound"
                    values={{
                        partner: partner?.id?.length
                            ? `${t('dashboard.for').toLowerCase()} ${
                                  partner.name
                              }`
                            : null,
                    }}
                    components={{ italic: <i />, bold: <strong /> }}
                />
            </Text>
        </InternalGrid>
    </Message>
);

export default withTranslation('common')(NoDataFoundMessage);
